import React from 'react'
import ReactDOM from 'react-dom/client'
import App from './App'
import { AuthProvider } from './contexts/auth.context'
import { AuthProvider as KeycloakAuthProvider } from 'react-oidc-context'
import { oidcConfig } from 'utils/keycloak.util'
import { SnackBarProvider } from './contexts/snackbar.context'
import { BackdropProvider } from './contexts/backdrop.context'
import { PromotoriaProvider } from './contexts/promotoria.context'

ReactDOM.createRoot(document.getElementById('root') as HTMLElement).render(
  <KeycloakAuthProvider {...oidcConfig}>
    <SnackBarProvider>
      <BackdropProvider>
        <AuthProvider>
          <PromotoriaProvider>
            <App />
          </PromotoriaProvider>
        </AuthProvider>
      </BackdropProvider>
    </SnackBarProvider>
  </KeycloakAuthProvider>,
)
